import React, { createContext, useContext, useEffect, useReducer } from 'react';
import PropTypes from '../helpers/propTypes';

const CloseConfirmationContext = createContext();

export function CloseConfirmationProvider({ children }) {
  const [{ lockCount }, dispatch] = useReducer(
    (state, action) => {
      if (action.type === 'add') return { lockCount: state.lockCount + 1 };
      else if (action.type === 'remove')
        return { lockCount: state.lockCount - 1 };
      return state;
    },
    { lockCount: 0 },
  );

  return (
    <CloseConfirmationContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        lockCount,
        dispatch,
      }}
    >
      {children}
    </CloseConfirmationContext.Provider>
  );
}

CloseConfirmationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useCloseConfirmation(enable = true) {
  const { dispatch } = useContext(CloseConfirmationContext);

  useEffect(() => {
    if (enable) {
      dispatch({ type: 'add' });

      return () => dispatch({ type: 'remove' });
    }

    return () => {};
  }, [enable]);
}

export function useIsLocked() {
  const { lockCount } = useContext(CloseConfirmationContext);

  return lockCount > 0;
}
